import React from "react";
import { ArrowUp, MapPin, Eye, Sparkles } from "lucide-react";

const CONF = {
  observed: { label: "Observed", color: "#5F8213", Icon: Eye },
  estimated: { label: "Estimated", color: "#A9781F", Icon: Sparkles },
};

export default function LocalPosition({ local }) {
  if (!local) return null;
  const { position, field_size, movement, verified, category_ranks = [] } = local;
  return (
    <div className="card p-6 sm:p-7 h-full" data-testid="local-position-card">
      <div className="flex items-center gap-2">
        <span className="grid place-items-center w-7 h-7 rounded-lg" style={{ background: "var(--grad-green-soft)" }}><MapPin size={15} strokeWidth={2} color="#5F8213" /></span>
        <span className="label-caps">Local position</span>
        <span className="ml-auto text-[10px] font-bold uppercase tracking-wide rounded-full px-2 py-0.5" style={{ background: verified ? "rgba(147,192,32,.14)" : "#F1F2EE", color: verified ? "#5F8213" : "#6B6E62" }}>
          {verified ? "Verified rank" : "Estimated position"}
        </span>
      </div>
      <div className="flex items-end gap-3 mt-4">
        <span className="text-5xl font-extrabold tracking-tighter text-ink leading-none">#{position}</span>
        <span className="text-xl font-semibold text-ink-3 mb-1">of {field_size}</span>
        {movement ? (
          <span className="ml-auto inline-flex items-center gap-1 text-sm font-bold mb-1" style={{ color: "#678A16" }}>
            <ArrowUp size={15} strokeWidth={2.5} /> {movement} position{movement > 1 ? "s" : ""}
          </span>
        ) : null}
      </div>
      <div className="mt-5 space-y-2.5">
        {category_ranks.map((r) => {
          const c = CONF[r.confidence] || CONF.estimated;
          const Icon = c.Icon;
          return (
            <div key={r.key} className="flex items-center gap-3" data-testid={`local-rank-${r.key}`}>
              <span className="text-sm text-ink-2 flex-1">{r.label}</span>
              <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wide" style={{ color: c.color }}><Icon size={10} strokeWidth={2.5} />{c.label}</span>
              <span className="text-sm font-bold text-ink w-10 text-right">#{r.rank}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
